import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Right32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconRotate90Right32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 17v5H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6h-5a4 4 0 0 0-4 4m-1 7h1v1a4 4 0 0 0 4 4h13a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4h-6V7a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v13a4 4 0 0 0 4 4m20 1v-8a2 2 0 0 0-2-2H12a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2M22 3h-1v2h2a4 4 0 0 1 4 4v2h2V9a6 6 0 0 0-6-6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRotate90Right32);
